import { AgentApiError } from './client';

export const getAgentApiErrorMessage = (error: unknown) => {
  if (!(error instanceof AgentApiError)) {
    return 'Не удалось загрузить данные. Попробуйте ещё раз';
  }

  if (error.fields?.email?.includes('email_taken')) {
    return 'Эта почта уже используется другим клиентом агентства';
  }

  switch (error.code) {
    case 'invalid_query':
      return 'Не удалось применить поисковый запрос';
    case 'not_found':
      return 'Запись не найдена';
    case 'validation_error':
      return 'Проверьте заполненные поля';
    case 'forbidden':
      return 'Недостаточно прав для этого действия';
    case 'too_many_requests':
      return 'Слишком много запросов. Попробуйте позже';
    default:
      return 'Не удалось загрузить данные. Попробуйте ещё раз';
  }
};
